import React, {useState, useEffect} from 'react';
import { connect } from "react-redux";
import Header from '../../components/header';
import Banner from '../../components/banner';
import Lottery from '../../components/lottery';
import Gifts from '../../components/gifts';
import Rules from '../../components/rules';
import Modal from '../../components/Modal';
import LoginModal from '../../components/LoginModal';
import PayModal from '../../components/PayModal';
import RegModal from '../../components/regModal';
import MyGiftModal from '../../components/myGiftModal';
import AddressModal from '../../components/AddressModal';
import UpgradeModal from '../../components/upgradeModal';
import WinModal from '../../components/winModal';

import globalAction from '../../actions/global';
import { linkToUpdate, isPc, getQueryString } from '../../utils/util';
import { getUser, getPrizes, getMyPrizes, getBalance, getAddress, getProbability, getFinish } from '../../pages/api';

import './index.css';
import '../../components/header/index.css';
import '../../components/banner/index.css';
import '../../components/lottery/index.css';
import '../../components/swiper/index.css';
import '../../components/rules/index.css';
import '../../components/gifts/index.css';
import '../../components/LoginModal/index.css';
import '../../components/myGiftModal/index.css';
import '../../components/upgradeModal/index.css';
import '../../components/PayModal/index.css';
import '../../components/regModal/index.css';
import '../../components/winModal/index.css';
import '../../components/AddressModal/index.css';
import '@mailvip/reg-pay/dist/index.esm.css';


if (!isPc()) {
  window.location.href = './wap.html' + window.location.search;
}

try {
  window.Tongji.init({
    debug: false,
    type: 'pin_act', 
    activity: '200618-vip'
  });
  window.Tongji.pv('p_200618_index', {'utm_source': getQueryString('utm_source')}); 
} catch (error) {
  
}

function App({
  userData, 
  isLoginVisible, 
  isMyPrizesModalVisible, 
  isAddressModalVisible, 
  isOfflineModalVisible, 
  isUpgradeModalVisible, 
  isOffline,
  setUserData, 
  setPrizes, 
  setRecords, 
  setBalance,
  setAddress,
  setOffline,
  setPhoneDrawRecordId,
  setProbabilityList,
  hideLoginModal, 
  toggleMyPrizesModal, 
  toggleAddressModal, 
  toggleOfflineModalVisible, 
  toggleUpgradeModal}) {

  const [isUsedUpModalVisible, setIsUseUpModalVisible] = useState(false);
  async function __getAddress(drawRecordId) {
      const {result} = await new getAddress({drawRecordId: drawRecordId}).fetch();
      if (result.code === 200 && result.result && result.result.userAddress) {
          setAddress(result.result.userAddress);
      }
  }

  async function __getUser() {
      const {result} = await new getUser({}).fetch();
      if (result.code === 200 && result.result && result.result.user) {
          setUserData(result.result.user);
          try {
            window.Tongji.click('b_account_login', {uid: result.result.user.uid}); 
          } catch (error) {}
      }
  }

  async function __getPrizes() {
      const {result} = await new getPrizes({}).fetch();
      if (result.code === 200 && result.result && result.result.list) {
        setPrizes(result.result.list);
      }
  }

  async function __getBalance() {
    const {result} = await new getBalance({}).fetch();
    if (result.code === 200 && result.result && result.result.balance >= 0) {
        setBalance(result.result.balance);
    }
  }

  async function __getMyPrizes() {
      const {result} = await new getMyPrizes({}).fetch();
      if (result.code === 200 && result.result && result.result.list) {
        const list = result.result.list;
        setRecords(list);
        // 获取收货地址
        list.forEach(item => {
          if (item.prizeId === 5 && item.drawRecordId) {
            setPhoneDrawRecordId(item.drawRecordId);
            __getAddress(item.drawRecordId);
          }
        });
      }
  }

  async function __getProbability() {
    const {result} = await new getProbability({}).fetch();
      if (result.code === 200 && result.result && result.result.list) {
        const list = result.result.list;
        setProbabilityList(list);
      }
  }

  async function __getFinish() {
    const {result} = await new getFinish({}).fetch();
      if (result.code === 213) {
        setOffline(true);
        toggleOfflineModalVisible(true)
      }
  }

  const __hideUseUpModalVisible = () => {
    setIsUseUpModalVisible(false);
  }

  const handleViewMyGift = () => {
    setIsUseUpModalVisible(false);
    toggleMyPrizesModal(true);
  }

  const handleShowSubmitAddr = () => {
    toggleMyPrizesModal(false);
    toggleAddressModal(true);
  }

  useEffect(() => {
    __getUser();
    __getFinish();
    __getPrizes();
    __getMyPrizes();
    __getBalance();
    __getProbability();
  }, []);

  function __hideLoginModal() {
    hideLoginModal();
  }

  return (
    <div className="App">
      <Header></Header>
      <Banner></Banner>
      <Lottery onUseUp={() => {setIsUseUpModalVisible(true)}} afterLottery={() => {__getMyPrizes();__getBalance();}}></Lottery>
      <Gifts></Gifts>
      <Rules></Rules>

      <LoginModal isOpen={isLoginVisible} onClose={__hideLoginModal}></LoginModal>
      <MyGiftModal isOpen={isMyPrizesModalVisible} onClose={() => {toggleMyPrizesModal(false)}} submitAddr={handleShowSubmitAddr}></MyGiftModal>
      <AddressModal isOpen={isAddressModalVisible} onClose={() => {toggleAddressModal(false)}}></AddressModal>
      <UpgradeModal isOpen={isUpgradeModalVisible} onClose={() => {toggleUpgradeModal(false)}} confirmClick={() => {linkToUpdate(userData.uid);}}></UpgradeModal>
      <PayModal onPaySuc={() => {__getBalance()}} onClose={() => {__getBalance()}}></PayModal>
      <RegModal onRegSuc={() => {__getBalance()}}></RegModal>
      <WinModal></WinModal>

      
      <Modal isOpen={isUsedUpModalVisible} title="" className="w-useUp-modal" onClose={() => {__hideUseUpModalVisible()}}>
          <div className="w-useUp-modal-con1">您的2次翻牌机会已用完，感谢您对活动的支持！</div>
          <div className="w-useUp-modal-con2">
            <button className="w-button" onClick={handleViewMyGift}>查看我的礼品</button>
          </div>
      </Modal>

      <Modal isOpen={isOfflineModalVisible} title="" className="w-offline-modal" onClose={() => {toggleOfflineModalVisible(false)}}>
          <div className="w-offline-modal-con1">活动已结束，感谢您的关注！</div>
          <div className="w-offline-modal-con2">如有任何问题咨询，可拨打管家专线：400-9163-163</div>
      </Modal>
    </div>
  );
}


function mapStateToProps(state) {
  return {
      userData: state.global.userData,
      isLoginVisible: state.global.isLoginVisible,
      isMyPrizesModalVisible: state.global.isMyPrizesModalVisible,
      isAddressModalVisible: state.global.isAddressModalVisible,
      isOfflineModalVisible: state.global.isOfflineModalVisible,
      isOffline: state.global.isOffline,
      isUpgradeModalVisible: state.global.isUpgradeModalVisible
  }
}

function mapDispatchToProps(dispatch) {
  return {
    hideLoginModal() {
      dispatch(globalAction.toggleLoginModal(false));
    },
    toggleMyPrizesModal(flag) {
      dispatch(globalAction.toggleMyPrizesModal(flag))
    },
    setUserData(data) {
      dispatch(globalAction.setUserData(data));
    },
    setPrizes(list) {
      dispatch(globalAction.setPrizes(list));
    },
    setRecords(list) {
      dispatch(globalAction.setRecords(list));
    },
    setBalance(num) {
      dispatch(globalAction.setBalance(num));
    },
    toggleAddressModal(flag) {
      dispatch(globalAction.toggleAddressModal(flag));
    },
    setAddress(addr) {
      dispatch(globalAction.setAddress(addr));
    },
    toggleOfflineModalVisible(flag) {
      dispatch(globalAction.toggleOfflineModalVisible(flag));
    },
    toggleUpgradeModal(flag) {
      dispatch(globalAction.toggleUpgradeModal(flag));
    },
    setProbabilityList(list) {
      dispatch(globalAction.setProbabilityList(list));
    },
    setPhoneDrawRecordId(id) {
      dispatch(globalAction.setPhoneDrawRecordId(id));
    },
    setOffline(flag) {
      dispatch(globalAction.setOffline(flag));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
